import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'

import menu from './menu'
import localization from "./common/localization"
import people from "./people";
import project from "./project";
import search from "./search";
import event from "./event";
import video from "./video";
import title from "./common/title";
import media from "./media";
import ui from "./ui";
import file from "./file";
import partner from "./partner";
import color from "./color";
import home from "./home";
import VuexPersistence from 'vuex-persist'
import folder from "./folder";

const debug = process.env.NODE_ENV !== 'production';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
    storage: window.sessionStorage,
    modules: ['search', 'video', 'event'],
});

const vuexLocalStorage = new VuexPersistence({
    storage: window.localStorage,
    modules: ['localization'],
});

export default new Vuex.Store({
    modules: {
        menu: menu,
        localization: localization,
        search: search,
        event: event,
        people: people,
        project: project,
        video: video,
        title: title,
        media: media,
        ui: ui,
        file: file,
        partner: partner,
        color: color,
        home: home,
        folder: folder,
    },
    strict: debug,
    plugins: debug ? [createLogger(), vuexLocal.plugin, vuexLocalStorage.plugin] : [vuexLocal.plugin, vuexLocalStorage.plugin]
})
